import Paper from '@mui/material/Paper';
import { FC, ReactNode } from 'react';
import { BaseModal } from '../BaseModal';

interface ConfirmModalProps {
  onClose: () => void;
  open: boolean;
  children: ReactNode;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({ open, children, onClose }) => {
  return (
    <BaseModal open={open} onClose={onClose}>
      <Paper
        variant="outlined"
        sx={(theme) => ({
          position: 'absolute',
          width: '90%',
          maxWidth: '530px',
          maxHeight: '80%',
          padding: theme.spacing(2, 3, 3),
          top: `${40}%`,
          left: `${50}%`,
          transform: `translate(-${50}%, -${50}%)`,
          borderRadius: '16px',
        })}
      >
        {children}
      </Paper>
    </BaseModal>
  );
};
